<template>
  <div class="strategyIndex view-container" ref="pageHeight">
    <xrk-head v-show="showHead" :hasBlank="true">攻略</xrk-head>
    <div class="strategyIndex_container body-container">
      <div class="navList">
        <ul class="clearfix">
          <li :class="tabName=='tbgl'?'active':''" @click="navClick('tbgl','10','2')">
            <div class="title">
              投保攻略
              <div v-show="tabName=='tbgl'" class="bar"></div>
            </div>
          </li>
          <li :class="tabName=='cpjd'?'active':''" @click="navClick('cpjd','40','2')">
            <div class="title">
              产品测评
              <div v-show="tabName=='cpjd'" class="bar"></div>
            </div>
          </li>
          <li :class="tabName=='bxbk'?'active':''" @click="navClick('bxbk')">
            <div class="title">
              保险百科
              <div v-show="tabName=='bxbk'" class="bar"></div>
            </div>
          </li>
          <li :class="tabName=='bxwd'?'active':''" @click="navClick('bxwd')">
            <div class="title">
              有问必答
              <div v-show="tabName=='bxwd'" class="bar"></div>
            </div>
          </li>
        </ul>
      </div>
      <div :is="tabName" :articletype="articletype" :articlecode="articlecode" ref="componentsView"></div>
    </div>
  </div>
</template>
<script>
//当前实例组件
var vm = null;
import tbgl from "@/pages/strategy/articleList"; //投保攻略
import cpjd from "@/pages/strategy/articleList"; //投保攻略
import bxbk from "@/pages/strategy/bxbk"; //保险百科
import bxwd from "@/pages/strategy/bxwd"; //保险问答
import xrkHead from "@/components/commons/xrkHead";
import loading from "@/components/commons/loading";
export default {
  data() {
    return {
      //底部导航
      navNumber: 2,
      tabName: "tbgl",
      articletype: "2",
      articlecode: "10",
      loaded: false,
      //是否显示顶部头部
      showHead: false
    };
  },
  components: {
    tbgl,                                                                                            
    cpjd,
    bxbk,
    bxwd,
    "app-loading": loading, //加载中
    "xrk-head": xrkHead
  },
  created() {
    vm = this;
    var shareParam = {
      title: "投保攻略_买保险注意事项_怎么买保险划算_ 梧桐树",
      desc: "梧桐树保险经纪提供专业的保险攻略及理赔攻略，教您如何买保险，专家视频讲解，保民投保经验分享。懂保险，买得更安心。"
    };
    this.$weixin.share(shareParam);
    this.showHead = !this.$tools.isAL();
    this.tabName = sessionStorage.tabName || "tbgl";
    this.articletype = sessionStorage.articletype || "2";
    this.articlecode = sessionStorage.articlecode || "10";
  },
  methods: {
    navClick(tabName, code, type) {
      if (this.tabName == tabName) return;
      this.tabName = tabName;
      sessionStorage.tabName = tabName;
      if (code) {
        this.articlecode = code;
        sessionStorage.articlecode = code;
      }

      if (type) {
        this.articletype = type;
        sessionStorage.articletype = type;
      }
    }
  },
  mounted() {
    setTimeout(() => {
      vm.loaded = true;
    }, 1000);
  },
  beforeRouteLeave (to, from, next) {
    sessionStorage.removeItem("tabName");
    sessionStorage.removeItem("articletype");
    sessionStorage.removeItem("articlecode");
    next();
  },
};
</script>
<style lang="scss">
.strategyIndex {
  background: #fff;
  height: 100vh;
  overflow: auto;
  .navList {
    li {
      float: left;
      width: 25%;
      font-size: r(31);
      line-height: 90px;
      text-align: center;
      padding: 0 r(15);
      .title {
        position: relative;
      }
      .bar {
        background: #3982f7;
        height: r(6);
        border-radius: r(3);
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      border-bottom: 1px solid #e6e6e6;
      &.active {
        color: #3982f7;
      }
    }
  }
}
</style>